import { useEffect } from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import { projects } from "../data/projects";
import useReveal from "../components/useReveal";

export default function CaseStudy() {
  const { slug } = useParams();
  const project = projects.find((p) => p.slug === slug);
  useReveal();

  useEffect(() => {
    if (project) document.title = `${project.name} — Sutranode`;
  }, [project]);

  if (!project) return <Navigate to="/work" replace />;
  if (!project.hasCaseStudy) return <Navigate to="/work" replace />;

  const cs = project.caseStudy;

  return (
    <section className="case-study-section">
      <div className="container cs-container">
        <Link to="/work" className="cs-back">← Back to all work</Link>

        <div className="cs-hero" data-reveal>
          <div className="cs-tag-row">
            <span className="cs-tag">{project.category}</span>
            {project.tags.map((t, i) => <span key={i} className="cs-tag">{t}</span>)}
          </div>
          <h1 className="cs-title">{project.name}</h1>
          <p className="cs-hero-text">{cs.hero}</p>
        </div>

        <div className="cs-body">
          <div className="cs-block" data-reveal>
            <div className="cs-block-label">The Challenge</div>
            <p>{cs.challenge}</p>
          </div>

          <div className="cs-block" data-reveal>
            <div className="cs-block-label">Our Approach</div>
            <p>{cs.approach}</p>
          </div>

          <div className="cs-block" data-reveal>
            <div className="cs-block-label">Results</div>
            <div className="cs-results-grid">
              {cs.results.map((r, i) => (
                <div key={i} className="cs-result-card">
                  <strong>{r.metric}</strong>
                  <span>{r.desc}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="cs-block" data-reveal>
            <div className="cs-block-label">Services</div>
            <div className="cs-service-chips">
              {cs.services.map((s, i) => <span key={i} className="cs-service-chip">{s}</span>)}
            </div>
          </div>
        </div>

        <div className="cs-footer-actions" data-reveal>
          <Link to="/contact" className="btn-gold">Start a conversation →</Link>
          <Link to="/work" className="btn-ghost">See more work</Link>
        </div>
      </div>
    </section>
  );
}
